export const environment = {
  production: false,
  apiUrl: "https://mdm-mam.moveinsync.in/mobile-application-manager",
  redirectUri: "https://mdm-mam.moveinsync.in/callback",
  googleRequestForm: "https://docs.google.com/forms/d/e/1FAIpQLSfXKxzMB79247l5p0BvTdL8NUtTt4FNtIv1jnPw6H4YJCbX8A/viewform?usp=pp_url&entry.1735820221=prod",
  googleRequestSheets: "https://docs.google.com/spreadsheets/d/1LGFz1_6pwY4b6FV4JGkWSJrxKEw9oqx7XxoCeBNWaXo/edit?usp=sharing",
  s3BucketPath:"mis-driver-data/app-update/prod/",
};
